import { motion } from "framer-motion";
import { Download, MapPin, Tv, Users } from "lucide-react";
import { AUDIENCE, PDF_FILENAME, PDF_URL, TOTALS } from "@/data/content";
import { Kicker, Reveal, Star } from "./Reveal";

const ICONS = { tv: Tv, female: Users, brasil: MapPin };
const TINT = { tv: "var(--yellow)", female: "var(--red)", brasil: "var(--green)" };

const AudienceCard = ({ a, i }) => {
  const Icon = ICONS[a.key];
  return (
    <Reveal delay={i * 0.1} className="h-full">
      <div data-testid={`audience-card-${a.key}`} className="flex h-full flex-col justify-between rounded-[2rem] border-2 border-white/15 bg-white/[0.06] p-6 backdrop-blur-sm sm:p-8">
        <span className="grid h-12 w-12 place-items-center rounded-2xl" style={{ background: TINT[a.key] }}>
          <Icon className="h-6 w-6 text-[var(--ink)]" />
        </span>
        <div className="mt-8">
          <p className={`font-display font-extrabold leading-none ${i === 0 ? "text-7xl sm:text-[8rem]" : "text-5xl sm:text-6xl"}`} style={{ color: TINT[a.key] }}>
            {a.big}
          </p>
          <h3 className="font-display mt-3 text-2xl font-bold text-white">{a.title}</h3>
          <p className="mt-1 text-white/80">{a.text}</p>
        </div>
      </div>
    </Reveal>
  );
};

export const MediaKit = () => (
  <section id="midia-kit" className="felt relative overflow-hidden bg-[var(--blue-deep)] px-5 py-24 text-white sm:px-8 sm:py-32" data-testid="mediakit-section">
    <Star className="floaty absolute right-[8%] top-16 h-16 w-16 opacity-90" />
    <div className="mx-auto max-w-6xl">
      <Reveal className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-8">
          <Kicker className="text-white/80">Mídia kit</Kicker>
          <h2 className="font-display mt-3 text-5xl font-extrabold leading-[0.95] sm:text-7xl">
            Números que <span className="text-[var(--yellow)]">brilham</span> na sala de estar.
          </h2>
          <p className="mt-5 max-w-xl text-base text-white/85 sm:text-lg" data-testid="mediakit-four-months-text">
            E o mais impressionante: tudo isso foi alcançado em <strong className="text-[var(--yellow)]">apenas 4 meses</strong> de canal.
          </p>
        </div>
        <div className="lg:col-span-4 lg:text-right">
          <motion.a
            href={PDF_URL}
            download={PDF_FILENAME}
            whileHover={{ scale: 1.04, rotate: -1 }}
            whileTap={{ scale: 0.96 }}
            data-testid="mediakit-download-pdf-button"
            className="inline-flex items-center gap-3 rounded-full bg-[var(--yellow)] px-7 py-4 font-bold text-[var(--ink)] shadow-[0_6px_0_#c58f0a]"
          >
            <Download className="h-5 w-5" /> Baixar mídia kit (PDF)
          </motion.a>
        </div>
      </Reveal>
      <div className="mt-14 grid gap-4 sm:grid-cols-3" data-testid="mediakit-totals">
        {TOTALS.map((t, i) => (
          <Reveal key={t.l} delay={i * 0.08}>
            <div className="rounded-[2rem] bg-white p-6 text-[var(--ink)]">
              <p className="font-display text-5xl font-extrabold leading-none text-[var(--blue)] sm:text-6xl">{t.v}</p>
              <p className="mt-2 text-sm font-semibold text-[var(--ink)]/70">{t.l}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <h3 className="font-display mb-6 mt-20 text-3xl font-extrabold sm:text-4xl">Quem nos assiste?</h3>
      <div className="grid gap-4 md:grid-cols-4 md:grid-rows-2">
        {AUDIENCE.map((a, i) => (
          <div key={a.key} className="md:col-span-2 md:first:row-span-2">
            <AudienceCard a={a} i={i} />
          </div>
        ))}
      </div>
    </div>
  </section>
);
